// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1293":"a511ae85","9576":"a511ae85"}[chunkId] + ".chunk.css";
};